import { CartLimitReachedModalController } from '../controllers/CartLimitReachedModalController';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export class CartSkuLimitReachedUseCase {
    private cartLimitController: CartLimitReachedModalController;
    private skuLimit: number;

    constructor(skuLimit: number) {
        this.cartLimitController = diContainer.get(serviceNames.cartLimitReachedModalController);
        this.skuLimit = skuLimit;
    }

    public execute = () => {
        this.cartLimitController.handleSkuLimitReached(this.skuLimit);
    };
}
